<!--
/*******************************************************************************
*@ 컴포넌트명   : QrDrwotAcno.vue
*@ 컴포넌트설명 : QR결제 출금계좌 컴포넌트
*@ 사용전문     : 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <article>
    <NOSComponent ref="NOS_COMPONENT" :component="this.NOS_INSTANCE.components" />
    <div class="form-row">
      <select-box
        ref="acno"
        :value.sync="selectedAcno"
        @selected="selected"
        :option-list.sync="list"
        :label="label"
        label-i18n="PCOP-02-03-01-07"
        :disabled="disabled"
        :readonly="readonly"
        :default-text.sync="defaultTextData"
        :arrowNone="arrowNone"
        template="drwot"
        cssType="latest"
        required="required"
      >
        <template #noData>
          <div class="notice normal">
            <div class="notice-tit">
              <p>{{ /*선택 가능한 계좌가 없습니다.*/ $t("MCOM-0000083") }}</p>
            </div>
            <div class="notice-cont">
              <p>{{ /*다음과 같은 이유로 계좌가 표시되지 않습니다.*/ $t("MCOM-0000071") }}</p>
              <ol class="olist olist-number-type info-guide">
                <li>
                  <span class="num">①</span>
                  {{ /*출금 계좌 이외에 내 계좌가 없는 경우*/ $t("MCOM-0000072") }}
                </li>
                <li>
                  <span class="num">②</span>
                  {{ /*거래 가능한 통화를 가진 계좌가 없는 경우*/ $t("MCOM-0000073") }}
                </li>
                <li v-if="isCorporationUser">
                  <span class="num">③</span>
                  {{ /*기업 사용자의 경우 이체 권한이 없는 경우*/ $t("MCOM-0000124") }}
                </li>
              </ol>
            </div>
          </div>
        </template>
      </select-box>
    </div>
    <div class="account-info -type4">
      <div class="bottom">
        <div class="item">
          <div class="tit">{{ /*출금 가능 금액*/ $t("MPAY-01-01-12-02") }}</div>
          <div class="dec">
            <span class="exchange-unit">{{ drwotAcno.cncycd }}</span>
            <span class="total">{{ $num(dpostBalInfo) }}</span>
          </div>
        </div>
        <div class="item">
          <div class="tit">{{ /*1일이체잔여한도*/ $t("MPAY-01-01-12-03") }}</div>
          <div class="dec highlight">
            <span class="exchange-unit">{{ drwotAcno.cncycd }}</span>
            <span class="total">{{ $num(dailyRmainClam) }}</span>
          </div>
        </div>
      </div>
    </div>
    <acno-password-action-sheet :NOS_INSTANCE_REFERANCE="NOS_INSTANCE" id="password" key="password" ref="acnoPassword" />
  </article>
</template>
<script>
import { mapGetters } from "vuex";
import { commonProps, valueProps, selectBoxProps } from "@/mixins/basicComponent";
import { RBF0400A40 } from "@/mixins/transfer";
import { mapFields } from "vuex-map-fields";
import AcnoPasswordActionSheet from "@/components/page/common/AcnoPasswordActionSheet";
import NOSComponent from "@/components/page/pluginFree/NOSComponent";
import NOSController from "@/components/page/pluginFree/NOSController";
import { RBF0404B40Param } from "@/mixins/nosKeypad";
export default {
  name: "QrDrwotAcno",
  mixins: [commonProps, valueProps, selectBoxProps, RBF0400A40, RBF0404B40Param],
  components: { AcnoPasswordActionSheet, NOSComponent },
  props: {
    authChkYn: {
      type: String,
      default: "0",
    },
    cncycd: String,
    page: String,
    pageOption: String,
    arrowNone: { type: Boolean, default: false, required: false },
  },
  data() {
    return {
      NOS_INSTANCE: new NOSController(this, {
        componentid: "NOS_COMPONENT",
        kpd: true,
      }),
      dpostBalInfo: 0,
      dailyRmainClam: 0,
      list: [],
      tempValue: "",
      tempData: "",
      selectedAcno: "",
    };
  },
  async created() {
    this.drwotAcno = ""; // 해당 페이지 접속할 때마다 초기화
    this.$log.info(this.approvalLineInfo);
    const res = await this.RBF0400A40CallDrwot();
    if (res.length > 0) {
      this.list = res;
      if (this.siteCode == this.$config.SITECODE_OGHCM && this.page != "qrPayment" && this.$route.params.drwotInit != "1") {
        // 베트남 메인출금계좌 디폴트값 설정
        let fvrtAcno = null;
        let fvrtText = "";
        this.list.forEach(item => {
          if (item.data.rpsntDrwotAcnYn == "1") {
            fvrtAcno = item.data;
            fvrtText = item.text;
          }
        });
        if (fvrtAcno != null) {
          let data = `${fvrtAcno.acno};${fvrtAcno.cncycd};${fvrtAcno.alias}`;
          this.selectedAcno = data;
          // this.setValue(data);
          this.selected(fvrtText, fvrtAcno);
        }
      }
      if (!_.isEmpty(this.drwotAcno)) {
        let data = `${this.drwotAcno.acno};${this.drwotAcno.cncycd};${this.drwotAcno.alias}`;
        this.setValue(data);
      }
    } else {
      // alert("데이터 없음");
    }
  },
  mounted() {
    this.NOS_INSTANCE.init();
  },
  computed: {
    ...mapFields("admin", ["approvalLineInfo"]),
    ...mapGetters(["isCorporationUser"]),
    defaultTextData: {
      get() {
        return this.defaultText;
      },
      set() {
        this.$emit("update:defaultText", this.defaultText);
      },
    },
  },
  methods: {
    drwotAcnoFilter(cncycd, page) {
      this.$refs.acno.setOptionList(this.makeListDrwot(null, cncycd, page));
      this.$log.info(this.$refs.acno.selectedData);

      this.drwotAcno = this.$refs.acno.selectedData;
      //this.$set(this, "drwotAcno", this.$refs.acno.selectedData);
      this.$emit("update:value", this.$refs.acno.selectedValue);
      this.$emit("update:detailValue", this.$refs.acno.selectedData);
    },
    setValue(value) {
      console.log("value : " + value);
      this.$refs.acno.setValue(value);
      if (this.selectedAcno == "") this.selectedAcno = value;
      // this.selected = value;
    },
    selected(text, data) {
      this.$parent.init();
      this.dpostBalInfo = 0;
      this.dailyRmainClam = 0;
      this.tempValue = this.selectedAcno;
      this.tempData = data;
      this.$refs.acno.selectedIndex = -1;
      this.$refs.acno.selectedValue = "";
      this.$refs.acno.selectedData = {};
      if (!_.isEmpty(text) || !_.isNil(data)) {
        this.$set(this.incaKepad, "acno0", data.acno);
        this.$refs.acnoPassword.init();
        setTimeout(() => {
          this.$refs.acnoPassword.$refs.password.focus();
        }, 200);
      }
      this.$parent.$forceUpdate();
    },
    successCallBack() {
      this.dpostBalInfo = this.tempData == "" ? 0 : this.tempData.dpostBal;
      this.dailyRmainClam = this.tempData == "" ? 0 : this.tempData.dailyRmainClam;

      this.$refs.acno.setValue(this.tempValue);
      this.drwotAcno = this.tempData;
      //this.$set(this, "drwotAcno", this.tempData);
      this.$emit("change", this.tempData);
      this.$parent.$forceUpdate();
    },
  },
};
</script>
